import React from "react";

export const getSortedComponents = (Components = []) => {
  Components.sort((comp1, comp2) => comp1.order - comp2.order);
  return Components.map((Component, index) => <Component.Item key={index} />);
};
